/**
 * CMS content only stores Telugu + English.
 * UI languages ta/kn fall back to English when available, else Telugu.
 */

export function prefersEnglishContent(lang) {
  return lang === 'en' || lang === 'ta' || lang === 'kn';
}

/** Pick TE or EN field based on UI language. */
export function pickTeEn(lang, teVal, enVal) {
  const te = teVal == null ? '' : String(teVal);
  const en = enVal == null ? '' : String(enVal);
  if (prefersEnglishContent(lang)) {
    return en.trim() ? en : te;
  }
  return te.trim() ? te : en;
}
